export default {
    bulkReport: [],
    totalItems: null,
    totalPage: null,
    bulkAutoSubstitutingReport: [],
    autoSubstitutingTotalPage: null,
    autoSubstitutingTotalItems: null,
    bulkSms: [],
    bulkSmsTotalPage: null,
    bulkSmsTotalItems: null

};